import { isIosShell } from './platform';

/** Neutral copy for expired/trial-ended iOS users — no in-app payment path (#408). */
export const IOS_SUBSCRIPTION_MANAGE_MESSAGE =
  'Manage your subscription at maestrodesktop.com from a computer.';

/** Standalone billing routes that must not render commerce UI in the iOS shell. */
export const IOS_COMMERCE_PATHS = [
  '/subscribe',
  '/billing',
  '/manage-subscription',
  '/welcome-back',
] as const;

export function isIosCommercePath(pathname: string): boolean {
  const p = String(pathname || '').replace(/\/+$/, '') || '/';
  if (p === '/subscribe' || p.startsWith('/subscribe/')) return true;
  return (IOS_COMMERCE_PATHS as readonly string[]).includes(p);
}

/** True when Maestro billing/checkout/portal actions must be blocked in the iOS shell. */
export function isIosCommerceBlocked(): boolean {
  return isIosShell();
}
